/* eslint-disable max-len */
import { Component, Input, OnInit, ElementRef, Inject } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { AngularFirestore } from '@angular/fire/firestore';
import { format, parseISO, getDate, getMonth, getYear } from 'date-fns';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { SquareService } from 'src/app/services/square.service';
import { GroupService } from 'src/app/services/group.service';

@Component({
  selector: 'app-add-edit-square',
  templateUrl: './add-edit-square.component.html',
  styleUrls: ['./add-edit-square.component.scss'],
})
export class AddEditSquareComponent implements OnInit {

  @Input() public square: any;
  currentUser = this.authService.currentUser;
  squareForm;
  dateValue2;
  unsub1;
  groups = [];
  loading;
  constructor(
    public firestore: AngularFirestore,
    public modalCtrl: ModalController,
    public squareService: SquareService,
    public authService: AuthService,
    public formBuilder: FormBuilder,
    public toastController: ToastController,
    private el: ElementRef,
    private groupService: GroupService
  ) {
  }

  ngOnInit() { }

  async ionViewDidEnter() {
    this.groupService.getUserGroups(this.currentUser.id).then((groups: any) => {
      groups.forEach(group => {
        //change from 0 to whatever required afterwards
        if (group?.joined?.length > 499) {
          this.groups.push(group);
        }
      });
    });
    console.log('ionViewDidEnter AddEditSquareComponent', this.square);
    this.unsub1 = this.authService.currentAccount.subscribe(async (currentUser) => { this.currentUser = currentUser; });
    this.squareForm = this.formBuilder.group({
      name: [this.square?.name, [Validators.required, Validators.minLength(3)]],
      description: [this.square?.description],
      type: [this.square?.type || 'public', [Validators.required]],
      group: [this.square?.group, [Validators.required]],
      createdAt: [new Date(), [Validators.required]],
      recentlyActive: [new Date(), [Validators.required]],
    });
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  get errorCtr1() {
    return this.squareForm.controls;
  }

  enableIndexedSearch(str) {
    if (!(str?.length > 0)) {
      return undefined;
    }
    console.log(str);
    const search = [];
    for (let i = 1; i < str.length + 1; i++) {
      search.push(str.substring(0, i).toLowerCase());
    }
    return search.length > 0 ? search : undefined;
  }

  save() {
    this.loading = true;
    if (this.squareForm.valid) {
      const square = this.squareForm.getRawValue();
      square.admins = [this.currentUser.id];
      square.search = [];
      ['name', 'description'].forEach(elem => {
        if (square[elem]) {
          square.search = [...square.search, ...this.enableIndexedSearch(square[elem])];
        }
      });
      this.squareService.createOrUpdateSquare(this.square?.id, square).then(res => {
        this.presentToast(`Congratulations ${this.currentUser.displayName}`, `You have Successfully ${this.square?.id ? 'Updated the' : 'Created a'} Square!`);
        this.modalCtrl.dismiss({ updateSquare: true });
        this.loading = false;
      });
    } else {
      Object.keys(this.errorCtr1).forEach(key => {
        console.log(this.errorCtr1[key].valid);
        if (this.errorCtr1[key].valid === false) {
          this.presentToast(`Invalid ${key}`, `Please fill the ${key} Inputs provided!`);
          const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
          if (invalidControl) {
            this.loading = false;
            setTimeout(() => {
              invalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 2000);
            return;
          }
        }
      });
    }
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  async presentToast(header, message) {
    const toast = await this.toastController.create({
      header,
      message,
      position: 'middle',
      cssClass: 'spcl-toast',
      duration: 2000
    });
    await toast.present();

    const { role } = await toast.onDidDismiss();
    console.log('onDidDismiss resolved with role', role);
  }

  ionViewDidLeave() {
    this.unsub1.unsubscribe();
  }

}
